import React from 'react'
import { Route, Routes } from 'react-router-dom'

import BeneficiaryLogin from '@pages/beneficiaryLogin'
import RelatoryOptions from '@pages/beneficiaryLogin/relatoryOptions'
import ReportResult from '@/pages/reportResult'
import ChangePasswordByToken from '@/pages/changePasswordByToken'
import RecoverPassword from '@pages/recoverPassword'
import ConsentForm from '@pages/consentForm'

const LoginContainer = () => (
  <Routes>
    <Route element={<BeneficiaryLogin />} path="/" />
    <Route element={<ReportResult />} path="/beneficiario/:beneficiaryId/:collectionId" />
    <Route element={<RelatoryOptions />} path="/beneficiario/:beneficiaryId" />
    <Route element={<RelatoryOptions />} path="/app/:userId/:collectionId/:token" />
    <Route element={<ReportResult />} path="/beneficiario/report/:beneficiaryId" />
    <Route element={<ConsentForm />} path="/beneficiario/:beneficiaryId/termo-de-consentimento" />
    <Route
      element={<ChangePasswordByToken />}
      path="/changePasswordByToken/:url"
    />
    <Route
      element={<RecoverPassword />}
      path="/recuperar-senha"
    />
  </Routes>
)

export default LoginContainer
